import constants from "../constants";
import CommentsHooks from "./CommentsHooks";
import { useContext, useState } from "react";
import useAxiosPrivate from "./useAxiosPrivate";
import AlertContext from "../context/AlertContext";
import useCommonFunctionHooks from "./useCommonFunctionHooks";

export default function ApproveHooks() {
  const Alert = useContext(AlertContext);

  const axios = useAxiosPrivate();
  const { handleAddComments } = CommentsHooks();
  const { getCatchBlockDetails, getHeaderDetailsForAxios } =
    useCommonFunctionHooks();

  const [scoreChanged, setScoreChanged] = useState(false);
  const [tempScore, setTempScore] = useState(
    Alert.showBreadCrumbsData.type === constants.libTypeIds.SQL
      ? Alert.testDetail.data.sections[0].questions[
          Alert.testDetail.currentIndex
        ].actualscore
      : Alert.approveData.actualscore || 0,
  ); // ✅ local state for input

  const handleScoreSelect = (e) => {
    setScoreChanged(false);
  };

  const getPayLoadForAddGrade = (score) => {
    let payLoad = {
      newscore: score,
      libtypeid: Alert.showBreadCrumbsData.type,
      learnerid: Alert.showBreadCrumbsData.learnerId,
      lpconfigid: Alert.showBreadCrumbsData.lpConfigId,
    };

    if (
      Alert.showBreadCrumbsData.type ===
        constants.libTypeIds.CODING_CHALLENGE ||
      Alert.showBreadCrumbsData.type === constants.libTypeIds.SQL
    ) {
      // console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAS",Alert.showBreadCrumbsData.questionId, Alert.showBreadCrumbsData.testId )
      payLoad.commentdata = Alert.comment;
      payLoad.testid = Alert.showBreadCrumbsData.testId;
      payLoad.questionid =
        Alert.showBreadCrumbsData.questionId || Alert.testDetail.id;
    } else {
      payLoad.comments = Alert.comment;
      payLoad.questionid = Alert.showBreadCrumbsData.testId;
    }

    if (Alert.showBreadCrumbsData.mockUse) {
      payLoad.mockUse = true;
      payLoad.lmpid = Alert.showBreadCrumbsData.lmpid;
      payLoad.lmtid = Alert.showBreadCrumbsData.lmtid;
      payLoad.questionid = Alert.showBreadCrumbsData.questionId;
      payLoad.testid = Alert.showBreadCrumbsData.testId;
      payLoad.testconfigid = Alert.showBreadCrumbsData.testConfigId;
    }

    return JSON.stringify(payLoad);
  };

  const addGrade = (score) => {
    const targetscore =
      Alert.showBreadCrumbsData.type === constants.libTypeIds.SQL
        ? Alert.testDetail.data.sections[0].questions[
            Alert.testDetail.currentIndex
          ].targetscore
        : Alert.approveData.marks || Alert.testDetail.targetscore;
    if (score >= 0 && score <= targetscore) {
      Alert.setIsLoaded(true);
      axios
        .post(
          "node/admin/test/score",
          getPayLoadForAddGrade(score),
          getHeaderDetailsForAxios(),
        )
        .then((res) => {
          if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
            Alert.setShowReject(false);
            Alert.setShowApprove(false);
            Alert.approveData.actualscore = score;

            // ✅ Update Alert.testDetail only now
            Alert.setScore(score);
            if (Alert.showBreadCrumbsData.type === constants.libTypeIds.SQL) {
              const currentIndex = Alert.testDetail.currentIndex;
              Alert.setTestDetail((prev) => ({
                ...prev,
                data: {
                  ...prev.data,
                  sections: prev.data.sections.map((section) => ({
                    ...section,
                    questions: section.questions.map((item, qIndex) =>
                      qIndex === currentIndex
                        ? { ...item, actualscore: score }
                        : item,
                    ),
                  })),
                },
              }));
            }

            if (Alert.comment !== "") {
              handleAddComments("", "score");
            } else {
              Alert.setShowNotify({
                show: true,
                title: "Info",
                msg: "Score added successfully",
              });
            }
          } else {
            Alert.setShowNotify({
              show: true,
              title: "Error",
              msg: res.data.message ?? "Something went wrong",
            });
          }
        })
        .catch(function (error) {
          getCatchBlockDetails(error);
          // rollback local score if needed
          setTempScore(
            Alert.showBreadCrumbsData.type === constants.libTypeIds.SQL,
          );
        })
        .finally(() => {
          Alert.setIsLoaded(false);
        });
    } else {
      Alert.setShowNotify({
        show: true,
        title: "Info",
        msg: "Invalid marks",
      });
    }
  };

  // const changeScore = (e) => {
  //   if (e.target.value === "") {
  //     setScoreChanged(false);
  //   }

  //   if (
  //     (e.target.value + "").length >
  //       (Alert.testDetail.actualscore + "").length ||
  //     (e.target.value + "").length > (Alert.approveData.actualscore + "").length
  //   ) {
  //     setScoreChanged(false);
  //   }

  //   if (isNaN(e.target.value) || e.target.value === "") {
  //     Alert.setScore(0);

  //     if (Alert.testDetail.libtypeid === constants.libTypeIds.SQL) {
  //       const currentIndex = Alert.testDetail.currentIndex;
  //       Alert.setTestDetail((prev) => ({
  //         ...prev,
  //         actualscore: 0,
  //         data: {
  //           ...prev.data,
  //           sections: prev.data.sections.map((section) => ({
  //             ...section,
  //             questions: section.questions.map((item, qIndex) => (
  //               qIndex === currentIndex
  //               ? {...item, actualscore: 0}
  //               : item
  //             )),
  //           })),
  //         },
  //       }));
  //     }

  //     setScoreChanged(false);
  //   } else {
  //     Alert.setScore(Number(e.target.value));

  //     if (Alert.testDetail.libtypeid === constants.libTypeIds.SQL) {
  //       const currentIndex = Alert.testDetail.currentIndex;

  //       console.log("currentIndex", currentIndex);

  //       Alert.setTestDetail((prev) => ({
  //         ...prev,
  //         // actualscore: Number(e.target.value), // if this should reflect total, remove it
  //         data: {
  //           ...prev.data,
  //           sections: prev.data.sections.map((section, sIndex) => ({
  //             ...section,
  //             questions: section.questions.map((item, qIndex) =>
  //               qIndex === currentIndex
  //                 ? { ...item, actualscore: Number(e.target.value) } // ✅ update only current question
  //                 : item
  //             ),
  //           })),
  //         },
  //       }));
  //     }

  //     if (
  //       Number(e.target.value) >= 0 &&
  //       (Number(e.target.value) <= Alert.approveData.marks ||
  //         Number(e.target.value) <= Alert.testDetail.targetscore)
  //     ) {
  //       Alert.setIsScore(true);

  //       if (
  //         Number(e.target.value) !== Alert.testDetail.actualscore ||
  //         Number(e.target.value) !== Alert.approveData.actualscore
  //       ) {
  //         setScoreChanged(true);
  //         Alert.setScore(Number(e.target.value));
  //       } else {
  //         setScoreChanged(false);
  //       }
  //     } else {
  //       Alert.setIsScore(false);
  //       setScoreChanged(false);
  //     }
  //   }
  // };

  const changeScore = (e) => {
    const value = e.target.value;
    const targetscore =
      Alert.showBreadCrumbsData.type === constants.libTypeIds.SQL
        ? Alert.testDetail.data.sections[0].questions[
            Alert.testDetail.currentIndex
          ].targetscore
        : Alert.approveData.marks || Alert.testDetail.targetscore;

    // Update local state only
    setTempScore(value);

    // Always update global Alert score so UI can show it immediately
    Alert.setScore(value === "" ? 0 : Number(value));

    if (isNaN(value) || value === "") {
      setScoreChanged(false);
      return;
    }

    if (Number(value) >= 0 && Number(value) <= targetscore) {
      setScoreChanged(true);
    } else {
      setScoreChanged(false);
    }
  };

  return {
    addGrade,
    changeScore,
    scoreChanged,
    handleScoreSelect,
    tempScore,
    setTempScore,
  };
}
